(function (window, undefined) {
  const {acpv: {EventTarget} = {}} = window;

  if (EventTarget === undefined) {
    throw new Error(`
      Missing dependency EventTarget.
      Please include event-target.js before this file.
    `);
  }

  class Map extends EventTarget {
  
    // public
    size = 0;
  
    // private
    _store = Object.create(null);
  
    constructor(object = {}) {
      super();
      this.setMany(object);
    }
  
    clear() {
      this._store = Object.create(null);
      this.size = 0;
      this.emit({type: 'change'});
      this.emit({type: 'clear'});
    }
  
    delete(key) {
      if (!this.has(key)) {
        return;
      }
  
      delete this._store[key];
      this.size--;
  
      this.emit({type: 'change'});
      this.emit({type: 'delete', key});
    }
  
    entries() {
      return Object.entries(this._store);
    }
  
    get(key, value) {
      return this._store[key];
    }
  
    has(key) {
      return key in this._store;
    }
  
    keys() {
      return Object.keys(this._store);
    }
  
    set(key, value) {
      if (!this.has(key)) {
        this.size++;
      }
  
      this._store[key] = value;
  
      this.emit({type: 'change'});
      this.emit({type: 'set', key, value});
  
      return value;
    }
  
    setMany(object) {
      for (let key in object) {
        this.set(key, object[key]);
      }
  
      return object;
    }
  
    toJson() {
      return JSON.stringify(this._store);
    }
  
    toObject() {
      return Object.assign({}, this._store);
    }
  
    values() {
      return Object.values(this._store);
    }
  }
  
  // Map.prototype[Symbol.iterator] = function* () {
  //   for (let key in this._store) {
  //     yield [key, this.get(key)];
  //   }
  // };
  
  window.acpv.Map = Map;
    
})(window)
